import React from 'react';
import { costRows } from '../data/salesContent';
export function CostSection() {
  return <section className="w-full bg-ink-900 py-16 sm:py-24" aria-labelledby="cost-title" style={{
    paddingBottom: "0px"
  }} data-id="element-58" data-mp="9beltxjgog0m">
      <div className="mx-auto max-w-3xl px-5" data-id="element-59" data-mp="4k6cf1i4sung">
        <h2 id="cost-title" className="text-center font-display text-[1.7rem] font-bold leading-tight text-white sm:text-4xl" data-id="element-60" data-mp="4iv9f3wifqxe">
          ⚖️ Every Week Without a System{' '}
          <span className="text-lilac-400" data-id="element-61" data-mp="3qtzdeb2ral8s">Costs You More Than $27</span>
        </h2>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-white/10" data-id="element-62" data-mp="3mq1jcesag0ml">
          {costRows.map(row => <li key={row.situation} className="flex flex-col gap-1 border-b border-white/10 bg-ink-700 px-5 py-4 last:border-b-0 sm:flex-row sm:items-center sm:justify-between sm:gap-6" data-id="element-63" data-mp="3hs9pvgbzw6ga">
              <span className="text-[15px] font-semibold text-white" data-id="element-64" data-mp="1fz20fe2o48go">{row.situation}</span>
              <span className="text-sm font-medium text-danger sm:text-right" data-id="element-65" data-mp="1b2bkqrurzevs">
                {row.cost}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-bold italic text-white sm:text-3xl" data-id="element-66" data-mp="p9xs92n0a3x8">
          The next week can be completely different.
        </p>
      </div>
    </section>;
}